<template>  
  <div id="debug-wrapper" class="">
    <div id="debug" v-if="!hide" class="small px-2 border border-primary border-top-0">
      <div>
        last update: <mz-date-display :timestamp="timestamp"></mz-date-display>
      </div>
      <div>
        <mz-screen-size></mz-screen-size>
      </div>
    </div>
    <div class="d-inline-block bg-primary rounded-bottom px-2 mb-0 pt-1">
      <a href="#" @click.prevent="toggle">
        <fa-icon v-if="!hide" icon="chevron-up"/>
        <fa-icon v-else icon="chevron-down"/>
      </a>
    </div>
  </div>
</template>

<script>
import DateDisplay from '@/components/general/DateDisplay'
import ScreenSize from '@/components/debug/ScreenSize'

export default {
  name: 'debug',
  data () {
    return {
      hide: true
    }
  },
  computed: {
    timestamp () {
      return this.$store.state.sensors.acy.timestamp
    }
  },
  methods: {
    toggle () {
      this.hide = !this.hide
    }
  },
  components: {
    mzDateDisplay: DateDisplay,
    mzScreenSize: ScreenSize
  }
}
</script>

<style scoped>
#debug-wrapper {
  position: fixed;
  top: 0;
  z-index: 999;
}

#debug {
  border-bottom-right-radius: 0.25rem;
  background-color: rgba(253, 196, 0, 0.25);
  padding-top: 5px;
}

a {
  color: white;
}

a:hover {
  color: black;
}
</style>





// WEBPACK FOOTER //
// src/components/debug/Debug.vue